module.exports = __webpack_public_path__ + "img/ksm.3a4bb44c.jpg";